import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/apiConfig";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("eudemonie_token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axios.get(`${API}/auth/me`)
        .then(r => setUser(r.data))
        .catch(() => { localStorage.removeItem("eudemonie_token"); delete axios.defaults.headers.common["Authorization"]; })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user?.role !== "VISITOR") return undefined;
    const interceptor = axios.interceptors.request.use(config => {
      const method = String(config.method || "get").toUpperCase();
      if (["GET", "HEAD", "OPTIONS"].includes(method)) return config;
      const message = "Mode Visiteur : consultation uniquement. Aucun enregistrement n’est autorisé.";
      toast.error(message, { id: "visitor-read-only" });
      const error = new Error(message);
      error.response = { status: 403, data: { detail: message } };
      error.visitorReadOnly = true;
      return Promise.reject(error);
    });
    return () => axios.interceptors.request.eject(interceptor);
  }, [user?.role]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    const { token, user: u } = r.data;
    localStorage.setItem("eudemonie_token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("eudemonie_token");
    delete axios.defaults.headers.common["Authorization"];
    setUser(null);
  };

  const refreshUser = async () => {
    const response = await axios.get(`${API}/auth/me`);
    setUser(response.data);
    return response.data;
  };

  return <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
